import { LanguageEnum } from "@perxis-auto/shared/lib";
import uzTranslation from "../../../assets/locales/uz/translation.json.js";
const formatShortDay = () => {
  return [
    "shortDay",
    // @ts-ignore
    (value, lng = LanguageEnum.Ru) => {
      if (lng && lng === LanguageEnum.Uz) {
        return uzTranslation.widgets.dealerMap.schedule.shortDays[value - 1];
      }
      return new Intl.DateTimeFormat(lng, {
        weekday: "short",
        timeZone: "UTC"
      }).format(new Date(Date.UTC(1970, 1, value + 1)));
    }
  ];
};
export {
  formatShortDay
};
